var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 50.457,
    cy: 50.0011,
    r: 50,
    fill: "#00B549"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4551 52.4538C26.7561 51.9988 26.9941 51.4738 27.3861 51.1168C28.1771 50.3888 29.4021 50.4098 30.2631 51.0608C30.4591 51.2078 30.6411 51.3828 30.8161 51.5578C34.2391 54.9808 37.6621 58.3968 41.0851 61.8268C41.2181 61.9598 41.3231 62.1138 41.5401 62.3728C41.7081 62.1348 41.8061 61.9528 41.9461 61.8128C51.2211 52.5168 60.5171 43.2278 69.8061 33.9318C70.5271 33.2108 71.3251 32.8118 72.3541 33.0918C74.0061 33.5328 74.6571 35.5138 73.5931 36.8508C73.4601 37.0188 73.3061 37.1798 73.1521 37.3338C63.2471 47.2388 53.3421 57.1438 43.4371 67.0488C42.4361 68.0498 41.3721 68.2738 40.3361 67.6788C40.0701 67.5248 39.8321 67.3148 39.6151 67.0978C35.5201 63.0098 31.4251 58.9288 27.3511 54.8128C26.9661 54.4208 26.7491 53.8608 26.4551 53.3778C26.4551 53.0698 26.4551 52.7548 26.4551 52.4468L26.4551 52.4538Z",
    fill: "#00B549"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.656,
    height: 35,
    fill: "white",
    transform: "translate(26.4551 33.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcons);
export default __webpack_public_path__ + "static/media/approved_icons.6dc89bdb8da26903bd4f10564708b83d.svg";
export { ForwardRef as ReactComponent };